// import React from 'react'
// import styled from 'styled-components'
// import { colors } from '../../../Shared/colors'

// export const ManageLeadsFirst = () => {
//   return (
//     <Main>
//         <Heading>
//             Add Client Information
//         </Heading>
//         <InputSection>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Lead ID:</h3>
//                     <input type="text" name="leadId" id="leadId" />
//                 </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>ID:</h3>
//                     <input type="text" name="Id" id="Id" />
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Date Added:</h3>
//                             <div>
//                                 <input type="date" name="dateAdded" id="dateAdded" />
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Name:</h3>
//                     <input type="text" name="name" id="name" />
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Project:</h3>
//                             <div>
//                             <select name="project" id="project">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>National ID:</h3>
//                     <input type="text" name="nationalId" id="nationalId" />
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Allocation:</h3>
//                     <input type="text" name="allocation" id="allocation" />
//                 </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Landline:</h3>
//                     <input type="text" name="landline" id="Landline" />
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Status:</h3>
//                             <div>
//                             <select name="status" id="status">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Cell:</h3>
//                     <input type="text" name="cell" id="cell" />
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Allocated Date:</h3>
//                             <div>
//                                 <input type="date" name="allocatedDate" id="allocatedDate" />
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Occupation:</h3>
//                     <input type="text" name="occupation" id="occupation" />
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Classification:</h3>
//                             <div>
//                             <select name="classification" id="classification">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Country Type:</h3>
//                             <div>
//                             <select name="countryType" id="countryType">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Shared With:</h3>
//                             <div>
//                             <select name="sharedWith" id="sharedWith">
//                                 <option value="" disabled selected>Choose Staff</option>
//                             </select>
//                             </div>
//                 </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Buying Intent:</h3>
//                             <div>
//                             <select name="buuingIntent" id="BuyingIntent">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Date Shared:</h3>
//                             <div>
//                                 <input type="date" name="dateShared" id="dateShared" />
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Client Type:</h3>
//                             <div>
//                             <select name="clientType" id="clientType">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                 </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Source:</h3>
//                             <div>
//                             <select name="source" id="source">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//                 <RowPart>
//                 <InputFeild>
//                             <h3>Client Rating:</h3>
//                             <div>
//                             <select name="clientRating" id="clientRating">
//                                 <option value="" disabled selected>Select</option>
//                             </select>
//                             </div>
//                         </InputFeild>
//                 </RowPart>
//             </Row>
//             <Row>
//                 <RowPart>
//                 <InputFeild>
//                     <h3>Occupation:</h3>
//                     <input type="text" name="occupation" id="occupation" />
//                 </InputFeild>
//                 </RowPart>
//                 <RowPart3>
//                     <div>
//                         <InputFeild>
//                             <h3>Income/Month:</h3>
//                             <input type="text" name="income/month" id="income/month" />
//                         </InputFeild>
//                     </div>
//                     <div>
//                         <InputFeild>
//                         <h3>Min:</h3>
//                         <input type="text" name="min" id="min" />
//                         </InputFeild>
//                     </div>
//                     <div>
//                         <InputFeild>
//                             <h3>Max:</h3>
//                             <input type="text" name="max" id="max" />
//                         </InputFeild>
//                     </div>
//                 </RowPart3>
//             </Row>
//         </InputSection>
//     </Main>
//   )
// }

// const Main = styled.div`
// width: 90%;
// margin-top: 2em;
// background-color: ${colors.white};
// min-height: 60vh;
// padding: 1em;
// display: flex;
// flex-direction: column;
// align-items: center;
// `

// const Heading = styled.div`
// font-size: clamp(1.2em,1.2vw,2.2em);
// width: 100%;
// margin-top: 1em;
// `
// const InputSection = styled.div`
// width: 100%;
// display: flex;
// flex-direction: column;
// align-items: center;
// `

// const Row = styled.div`
// display: flex;
// justify-content: space-between;
// width: 100%;
// `

// const RowPart = styled.div`
// width: 45%;
// `

// const RowPart3= styled.div`
// width: 45%;
// display: flex;
// justify-content: space-between;
// `
// const InputFeild = styled.div`
// width: 100%;
// h3{
//   color: ${colors.black};
//   font-size: clamp(1em,1vw,2em);
//   margin: 1em 0em;
// }
// div{
//   position: relative;
//   border: 1px solid ${colors.inputBorderWhite};
//   border-radius: 6px;
//   width: 100%;
//   padding-right: 1em;
//   background-color: ${colors.inputWhite};
//   select,input[type=date]{
//   background-color: ${colors.inputWhite};
//   width: 100%;
//   padding: 1em 0em 1em 1em;
//   outline: none;
//   border: none;
//   ::placeholder{
//     color: ${colors.inputFeild};
//   }
// }
// }
// input{
//   border: 1px solid ${colors.inputBorderWhite};
//   border-radius: 6px;
//   background-color: ${colors.inputWhite};
//   width: 100%;
//   padding: 1em 0em 1em 1em;
//   outline: none;
//   ::placeholder{
//     color: ${colors.inputFeild};
//   }
// }
// `

import React, { useMemo, useState, useEffect } from "react";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { colors } from "../../../Shared/colors";
import {
  useGetSingleHierarchyQuery,
  useGetActiveStaffQuery,
} from "../../../features/employeeSlice";
import { useGetAllProjectsQuery } from "../../../features/projectSlice";
import { useGetClientsForDropdownQuery } from "../../../features/clientSlice";
import { useLazyGetManageLeadsFilterQuery } from "../../../features/leadsSlice";
import { useLazyGetTelesalesManagedLeadsQuery } from "../../../features/telesaleleadsSlice";
import { toast, Toaster } from "react-hot-toast";
import { ManageLeadsDataTable } from "./ManageLeadsDataTabel";
import { decryptData } from "../../../services/crypto";
import { usePaginationFromURL } from "../../../hooks/usePaginationFromURL";
export const ManageLeadsFirst = () => {
  // let staffId = decryptData(localStorage.getItem("id"));

  let staffId = null;
  let storedStaffId = localStorage.getItem("id");

  if (storedStaffId) {
    try {
      staffId = decryptData(storedStaffId);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }
  
  let staffName = null;
  let storedStaffName = localStorage.getItem("staffName");

  if (storedStaffName) {
    try {
      staffName = decryptData(storedStaffName);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  let role = null;
  let storedStaffRole = localStorage.getItem("role");

  if (storedStaffRole) {
    try {
      role = decryptData(storedStaffRole);
    } catch (error) {
      console.error("Failed to decrypt data:", error);
    }
  }

  const today = new Date();

  // const { data: hierarchyStaff } = useGetHierarchysubordinatesQuery(staffId);

  const { data: hierarchyStaff } = useGetSingleHierarchyQuery({ staffId });
  const { data: staff } = useGetActiveStaffQuery();

  // Initialize kpiData state first (before using it)
  const [kpiData, setkpiData] = useState({
    // start: '',
    // end: defaultDate,
    clientID: null,
    classification: "",
    source: "",
    numTasks: "",
    leadID: "",
    from: "",
    employeeID: null, // Will default to logged-in user
    project: "",
    taskType: "",
    taskSubType: "",
    clientType: "",
    phoneNumber: "",
    startDate: "",
    endDate: "",
    lastContact: "",
    quickFilter: "",
    inactiveLeads: "",
  });

  // Determine which employee ID to use for client dropdown
  // If staff member is explicitly selected, use that; otherwise pass undefined (backend will use logged-in user)
  const employeeIdForClients = (kpiData?.employeeID?.id && kpiData.employeeID.id !== "") 
    ? kpiData.employeeID.id 
    : undefined; // Pass undefined - backend will default to logged-in user

  const { data: clients } = useGetClientsForDropdownQuery(employeeIdForClients);

  const [trigger, { data: leadData, isFetching }] =
    useLazyGetManageLeadsFilterQuery();

  const [triggerTelesales, { data: telesalesLeadData, isFetching: isTelesalesFetching }] =
    useLazyGetTelesalesManagedLeadsQuery();

  // Debug logs for telesales data
  console.log("Role:", role);
  console.log("Telesales Lead Data:", telesalesLeadData);
  console.log("Regular Lead Data:", leadData);
  
  // Check data structure
  if (role === "ts" && telesalesLeadData) {
    console.log("Telesales data structure:", {
      success: telesalesLeadData.success,
      message: telesalesLeadData.message,
      leads: telesalesLeadData.leads,
      total: telesalesLeadData.total,
      leadsLength: telesalesLeadData.leads?.length
    });
  }

  const { data: project } = useGetAllProjectsQuery();

  const staffOptions = useMemo(() => {
    let options = [{ id: "", label: "Select Staff Member" }];
    hierarchyStaff?.map((staff) =>
      options.push({
        id: staff?._id,
        label: staff?.firstName + " " + staff?.lastName,
      })
    );

    return options;
  }, [hierarchyStaff]);

  const allStaffOptions = useMemo(() => {
    let options = [{ id: "", label: "Select Staff Member" }];
    staff?.map((staff) =>
      options.push({
        id: staff?._id,
        label: staff?.firstName + " " + staff?.lastName,
      })
    );

    return options;
  }, [staff]);

  const clientOptions = useMemo(() => {
    let options = [];
    // New dropdown endpoint returns clients in format: [{ id, label }]
    if (clients && Array.isArray(clients)) {
      clients.forEach((client) => {
        options.push({
          id: client.id,
          label: client.label,
        });
      });
    }
    return options;
  }, [clients]);

  const [taskSubTypeOptions, setTaskSubTypeOptions] = useState([]);
  const [searchFilters, setSearchFilters] = useState({
    projectID: "",
    classification: "",
    source: "",
    numTasks: "",
    leadID: "",
    employeeID: staffId,
    from: "",
    taskType: "",
    taskSubType: "",
    clientType: "",
    phoneNumber: "",
    startDate: "",
    endDate: "",
    lastContact: "",
    clientID: null,
    inactiveLeads: "",
  });
  // Use URL-based pagination hook (Note: DataGrid uses 0-indexed pages, but we'll convert)
  const { currentPage: urlPage, pageSize, setPage: setUrlPage, setPageSize } = usePaginationFromURL({
    defaultPage: 1,
    defaultPageSize: 50
  });
  // Convert to 0-indexed for DataGrid
  const currentPage = urlPage - 1;
  const setCurrentPage = (page) => {
    // Accept both 0-indexed (from DataGrid) and 1-indexed values
    const pageNum = typeof page === 'function' ? page(currentPage) : page;
    setUrlPage(pageNum >= 0 ? pageNum + 1 : 1);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setkpiData({
      ...kpiData,
      [name]: value,
    });
  };

  const handleTaskTypeChange = (e) => {
    const { name, value } = e.target;
    
    // Reset task sub-type when task type changes
    setkpiData({
      ...kpiData,
      [name]: value,
      taskSubType: "",
    });

    // Set task sub-type options based on task type
    if (value === "Call") {
      setTaskSubTypeOptions([
        "SMS",
        "Call connected",
        "Call Not Connected",
        "Whatsapp",
        "Followed Up",
      ]);
    } else if (value === "Meeting") {
      setTaskSubTypeOptions([
        "Vedio Meeting",
        "Head Office Meeting",
        "Outdoor",
        "Site",
        "Walk In"
      ]);
    } else if (value === "Sales") {
      setTaskSubTypeOptions([
        "Token Payment",
        "CLosed (Won)",
        "Closed (Lost)",
        "Complete Down Payment",
      ]);
    } else {
      setTaskSubTypeOptions([]);
    }
  };

  useEffect(() => {
    const {
      projectID,
      classification,
      source,
      numTasks,
      leadID,
      from,
      employeeID,
      taskType,
      taskSubType,
      clientType,
      leadStatus,
      phoneNumber,
      startDate,
      endDate,
      lastContact,
      clientID,
      inactiveLeads,
    } = searchFilters;
    
    if (role === "ts") {
      triggerTelesales({
        projectID,
        classification,
        source,
        leadID,
        taskType,
        taskSubType,
        clientType,
        phoneNumber,
        startDate,
        endDate,
        clientID,
        inactiveLeads,
        page: currentPage + 1,
        limit: pageSize,
      });
    } else {
      trigger({
        projectID,
        employeeId: employeeID,
        from,
        classification,
        source,
        numTasks,
        leadID,
        taskType,
        taskSubType,
        clientType,
        leadStatus,
        phoneNumber,
        startDate,
        endDate,
        lastContact,
        clientID,
        inactiveLeads,
        page: currentPage + 1,
        limit: pageSize,
      });
    }
  }, [currentPage, pageSize, searchFilters, role]);

  const handleSearch = () => {
    const {
      project,
      classification,
      source,
      numTasks,
      leadID,
      from,
      employeeID,
      taskType,
      taskSubType,
      clientType,
      leadStatus,
      phoneNumber,
      startDate,
      endDate,
      lastContact,
      clientID,
      inactiveLeads,
    } = kpiData;
    
    if (role === "ts") {
      triggerTelesales({
        projectID: project,
        classification,
        source,
        leadID,
        taskType,
        taskSubType,
        clientType,
        phoneNumber,
        startDate,
        endDate,
        clientID: clientID?.id || null,
        inactiveLeads,
        page: 1,
        limit: pageSize,
      })
        .then((res) => {
          toast.success("Telesales leads loaded successfully!");
        })
        .catch((err) => {
          toast.error(err.data.error.message);
        });
    } else {
      trigger({
        projectID: project,
        employeeId: employeeID?.id || staffId,
        from,
        classification,
        source,
        numTasks,
        leadID,
        taskType,
        taskSubType,
        clientType,
        leadStatus,
        phoneNumber,
        startDate,
        endDate,
        lastContact,
        clientID: clientID?.id || null,
        inactiveLeads,
        page: 1,
        limit: pageSize,
      })
        .then((res) => {
          toast.success("Leads loaded successfully!");
        })
        .catch((err) => {
          toast.error(err.data.error.message);
        });
    }
    
    setkpiData((prev) => ({
      classification: "",
      source: "",
      numTasks: "",
      leadID: "",
      employeeID: prev.employeeID,
      project: "",
      from: "",
      taskType: "",
      taskSubType: "",
      clientType: "",
      phoneNumber: "",
      startDate: "",
      endDate: "",
      lastContact: "",
      clientID: null,
      quickFilter: "",
      inactiveLeads: "",
    }));
    setTaskSubTypeOptions([]);
    
    setSearchFilters({
      projectID: project,
      employeeID: employeeID?.id || staffId,
      classification,
      source,
      numTasks,
      leadID,
      from,
      taskType,
      taskSubType,
      clientType,
      leadStatus,
      phoneNumber,
      startDate,
      endDate,
      lastContact,
      clientID: clientID?.id || null,
      inactiveLeads,
    });
    setCurrentPage(0);
  };

  return (
    <>
      <Main>
        <SearchContainer>
          <SearchHeader>
            <SearchTitle>
              <SearchIcon>🔍</SearchIcon>
              Manage Leads
            </SearchTitle>
            <FilterSubtitle>Search and filter your leads</FilterSubtitle>
          </SearchHeader>
          
          <SearchForm>
            <FormRow>
              <FormGroup>
                <FormLabel>Lead ID</FormLabel>
                <TextInput
                  type="text"
                  name="leadID"
                  id="leadID"
                  value={kpiData.leadID}
                  onChange={handleChange}
                  placeholder="Enter Lead ID"
                />
              </FormGroup>
              
              <FormGroup>
                <FormLabel>Client Name</FormLabel>
                <AutocompleteContainer>
                  <Autocomplete
                    id="client-autocomplete"
                    size="small"
                    options={clientOptions}
                    getOptionLabel={(option) => option.label}
                    onChange={(e, value) => {
                      setkpiData({ ...kpiData, clientID: value });
                    }}
                    value={kpiData.clientID || null}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Client"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: colors.white,
                            '& fieldset': {
                              borderColor: colors.inputBorderWhite,
                              borderWidth: '1px',
                            },
                            '&:hover fieldset': {
                              borderColor: colors.brown,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: colors.brown,
                              borderWidth: '2px',
                            },
                          },
                          '& .MuiInputBase-input': {
                            padding: '8px 12px',
                            fontSize: '13px',
                          },
                        }}
                      />
                    )}
                  />
                </AutocompleteContainer>
              </FormGroup>

              <FormGroup>
                <FormLabel>Phone Number</FormLabel>
                <TextInput
                  type="tel"
                  name="phoneNumber"
                  id="phoneNumber"
                  value={kpiData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                />
              </FormGroup>
              
              <FormGroup>
                <FormLabel>Project</FormLabel>
                <SelectInput
                  name="project"
                  id="project"
                  value={kpiData.project}
                  onChange={handleChange}
                >
                  <option value="">Select Project</option>
                  {project?.map((proj) => (
                    <option key={proj._id} value={proj._id}>{proj.projectName}</option>
                  ))}
                </SelectInput>
              </FormGroup>
            </FormRow>

            <FormRow>
              <FormGroup>
                <FormLabel>Classification</FormLabel>
                <SelectInput
                  name="classification"
                  id="classification"
                  value={kpiData.classification}
                  onChange={handleChange}
                >
                  <option value="">All Classifications</option>
                  <option value="veryHot">Very Hot</option>
                  <option value="hot">Hot</option>
                  <option value="moderate">Moderate</option>
                  <option value="cold">Cold</option>
                  <option value="veryCold">Very Cold</option>
                </SelectInput>
              </FormGroup>

              <FormGroup>
                <FormLabel>Source</FormLabel>
                <SelectInput
                  name="source"
                  id="source"
                  value={kpiData.source}
                  onChange={handleChange}
                >
                  <option value="">All Sources</option>
                  <option value="walkIn">Walk In</option>
                  <option value="Facebook">Facebook</option>
                  <option value="instagram">Instagram</option>
                  <option value="reference">Reference</option>
                  <option value="billboards">Bill Board</option>
                </SelectInput>
              </FormGroup>

              <FormGroup>
                <FormLabel>Task Type</FormLabel>
                <SelectInput
                  name="taskType"
                  id="taskType"
                  value={kpiData.taskType}
                  onChange={handleTaskTypeChange}
                >
                  <option value="">All Task Types</option>
                  <option value="Call">Call</option>
                  <option value="Meeting">Meeting</option>
                  <option value="Sales">Sales</option>
                </SelectInput>
              </FormGroup>

              <FormGroup>
                <FormLabel>Task Sub-Type</FormLabel>
                <SelectInput
                  name="taskSubType"
                  id="taskSubType"
                  value={kpiData.taskSubType}
                  onChange={handleChange}
                  disabled={!kpiData.taskType}
                >
                  <option value="">All Sub-Types</option>
                  {taskSubTypeOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                  </option>
                  ))}
                </SelectInput>
              </FormGroup>
            </FormRow>

            <FormRow>
              <FormGroup>
                <FormLabel>Assigned Staff</FormLabel>
                <AutocompleteContainer>
              <Autocomplete
                    id="staff-autocomplete"
                size="small"
                options={
                  role === "ceo" || role === "admin" || role === "account"
                    ? allStaffOptions
                    : staffOptions
                }
                getOptionLabel={(option) => option.label}
                onChange={(e, value) => {
                  // If value is null or "Select Staff Member" (empty id), set to null
                  // Otherwise, use the selected staff member
                  const newEmployeeID = (value && value.id && value.id !== "") 
                    ? value 
                    : null; // Set to null for "Select Staff Member"
                  
                  // Reset client selection when staff changes
                  setkpiData({ 
                    ...kpiData, 
                    employeeID: newEmployeeID,
                    clientID: null
                  });
                }}
                    value={kpiData.employeeID || null}
                renderInput={(params) => (
                  <TextField
                    {...params}
                        placeholder="Select Staff Member"
                    sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            backgroundColor: colors.white,
                            '& fieldset': {
                              borderColor: colors.inputBorderWhite,
                              borderWidth: '1px',
                            },
                            '&:hover fieldset': {
                              borderColor: colors.brown,
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: colors.brown,
                              borderWidth: '2px',
                            },
                          },
                          '& .MuiInputBase-input': {
                            padding: '8px 12px',
                            fontSize: '13px',
                          },
                    }}
                  />
                )}
              />
                </AutocompleteContainer>
              </FormGroup>

              <FormGroup>
                <FormLabel>Task Count</FormLabel>
                <SelectInput
                  name="numTasks"
                  id="numTasks"
                  value={kpiData.numTasks}
                  onChange={handleChange}
                >
                  <option value="">Any Count</option>
                  <option value="0">No Tasks</option>
                  <option value="1">1 Task</option>
                  <option value="2">2 Tasks</option>
                  <option value="moreThanTwo">More Than 2</option>
                </SelectInput>
              </FormGroup>

              <FormGroup>
                <FormLabel>Start Date</FormLabel>
                <DateInput
                  type="date"
                  name="startDate"
                  id="startDate"
                  value={kpiData.startDate}
                  onChange={handleChange}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>End Date</FormLabel>
                <DateInput
                  type="date"
                  name="endDate"
                  id="endDate"
                  value={kpiData.endDate}
                  onChange={handleChange}
                />
              </FormGroup>
            </FormRow>

            <FormRow>
              <FormGroup>
                <FormLabel>Inactive Leads</FormLabel>
                <SelectInput
                  name="inactiveLeads"
                  id="inactiveLeads"
                  value={kpiData.inactiveLeads}
                  onChange={handleChange}
                >
                  <option value="">All Leads</option>
                  <option value="30">30+ Days Inactive</option>
                  <option value="60">60+ Days Inactive</option>
                  <option value="90">90+ Days Inactive</option>
                </SelectInput>
              </FormGroup>
            </FormRow>
            
            <ActionRow>
              <SearchButton onClick={handleSearch} disabled={isFetching}>
                {isFetching ? (
                  <>
                    <Spinner />
                    Searching...
                  </>
                ) : (
                  <>
                    <SearchIcon>🔍</SearchIcon>
                    Search Leads
                  </>
                )}
              </SearchButton>
            </ActionRow>
          </SearchForm>
        </SearchContainer>
      </Main>
      <Toaster />
      <ManageLeadsDataTable
        leads={role === "ts" ? telesalesLeadData : leadData}
        isFetching={role === "ts" ? isTelesalesFetching : isFetching}
        currentPage={currentPage}
        totalPages={Math.ceil((role === "ts" ? telesalesLeadData?.total : leadData?.total) / pageSize)}
        pageSize={pageSize}
        setPageSize={setPageSize}
        setPage={setCurrentPage}
      />
    </>
  );
};

const Main = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0.75rem;
`;

const SearchContainer = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  box-shadow: 
    0 4px 20px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${colors.brown}, ${colors.textBlue});
    z-index: 1;
  }
`;

const SearchHeader = styled.div`
  padding: 1rem 1.25rem 0.5rem 1.25rem;
  border-bottom: 1px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.white} 100%);
`;

const SearchTitle = styled.h2`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.text};
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
`;

const SearchIcon = styled.span`
  font-size: 1.25rem;
  filter: grayscale(0.2);
`;

const FilterSubtitle = styled.p`
  color: ${colors.inputFeild};
  font-size: 0.85rem;
  margin: 0.25rem 0 0 0;
  font-weight: 400;
`;

const SearchForm = styled.div`
  padding: 1rem 1.25rem 1.25rem 1.25rem;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  @media (min-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

const FormLabel = styled.label`
  color: ${colors.text};
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.1rem;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const TextInput = styled.input`
  padding: 8px 12px;
    border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
    background-color: ${colors.white};
  color: ${colors.text};
  font-size: 0.8rem;
  transition: all 0.2s ease;
      outline: none;
  height: 36px;
  
  &:focus {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
  
  &::placeholder {
        color: ${colors.inputFeild};
    font-size: 0.75rem;
  }
  
  &:hover {
    border-color: ${colors.brown};
  }
`;

const DateInput = styled.input`
  padding: 8px 12px;
    border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
    background-color: ${colors.white};
  color: ${colors.text};
  font-size: 0.8rem;
  transition: all 0.2s ease;
    outline: none;
  height: 36px;
  
  &:focus {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
  
  &:hover {
    border-color: ${colors.brown};
  }
`;

const SelectInput = styled.select`
  padding: 8px 12px;
    border: 1px solid ${colors.inputBorderWhite};
  border-radius: 8px;
  background-color: ${colors.white};
  color: ${colors.text};
  font-size: 0.8rem;
  transition: all 0.2s ease;
  outline: none;
      cursor: pointer;
  height: 36px;
  
  &:focus {
    border-color: ${colors.brown};
    box-shadow: 0 0 0 2px rgba(36, 147, 147, 0.1);
  }
  
  &:hover {
    border-color: ${colors.brown};
  }
  
  &:disabled {
    background: #f8f9fa;
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  option {
    padding: 6px;
    font-size: 0.8rem;
  }
`;

const AutocompleteContainer = styled.div`
  width: 100%;
`;

const ActionRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid ${colors.inputBorderWhite};
`;

const SearchButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 20px;
  background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
  color: ${colors.white};
  border: none;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(36, 147, 147, 0.3);
  min-width: 140px;
  justify-content: center;
  height: 36px;
  
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(36, 147, 147, 0.4);
    background: linear-gradient(135deg, #1a6b6b 0%, ${colors.brown} 100%);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const Spinner = styled.div`
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid ${colors.white};
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
